import React from "react";

import { FormSection, FieldArray } from "redux-form";
import classNames from "classnames";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import { CLIENT_FORM } from "src/constants/FormNames";

import { useToasts } from "react-toast-notifications";

import Button from "jbc-front/components/Button";
import { Section } from "jbc-front/components/Form";
import scrollSpy, { AnchorTarget } from "jbc-front/components/ScrollSpy";
// import FormErrors, { LabelMapper } from 'jbc-front/components/FormErrors';
import Affix from "jbc-front/components/Affix";
import ListGroup from "jbc-front/components/ListGroup";
import { Anchor, ErrorsSection } from "src/components";
import { FormSubmitBtn, CancelBtn } from "src/buttons";
import { Panel, Headding, Item } from "src/components/PrimaryPanel";

import { CLIENT_SHOW } from "src/constants/EndpointUrls";
import * as CssClassNames from "src/constants/CssClassNames";
import ClientSection from "../containers/ClientSection";
import TaxIncomeContainer from "../containers/TaxIncomeContainer";
import ImageSection from "../containers/ImageSection";
// import LabourConsultantSection from '../containers/LabourConsultantSection';
import BanksSection from "./BanksSection";
import BranchSection from "./BranchSection";
// @TODO: Hide Provident Fund for Vietnam - comment out unused import
// https://donuts-vn.atlassian.net/browse/JBC-25
// import ProvidentFundSection from "./ProvidentFundSection";
import { useTranslation } from "react-i18next";
import styles from "./ClientForm.scss";


const DetailClientForm = ({ formValues, anyApiRunning, handleSubmit, submit, isNewForm, errors, pristine, submitting }) => {
  const { t } = useTranslation();
  const { addToast } = useToasts();

  return (
    <form className={classNames(CssClassNames.FORM, CssClassNames.CLIENT_FORM, styles.form)} onSubmit={handleSubmit}>
      <ErrorsSection errors={errors} />

      <AnchorTarget name="OfficeInfomation" />
      <Section title={t("features.Settings.Settings.office_information")}>
        <FormSection name="client">
          <ClientSection isNewForm={isNewForm} />
        </FormSection>
      </Section>

      <AnchorTarget name="BranchInfomation" />
      <Section title={t("features.Clients.components.BranchInfoSectionShow.branch_information")}>
        <div>
          <FieldArray name="clientBranch" component={BranchSection} isNewForm={isNewForm} />
        </div>
      </Section>

      {/* <Section title={t('features.Clients.components.TaxIncome.Client_tax_income')}>
          <FormSection name="clientTaxIncome">
            <TaxIncomeContainer isNewForm={isNewForm} />
          </FormSection>
        </Section> */}
      {/* <Section title={t('features.Clients.ShowClient.certified_labor_consultant_information')}>
          <FormSection name="clientLabourConsultant">
            <LabourConsultantSection />
          </FormSection>
      </Section> */}

      <AnchorTarget name="TransferSourseAccoutInformation" />
      <Section title={t("features.Clients.ShowClient.transfer_source_account_information")}>
        <div>
          <FieldArray name="clientBanks" component={BanksSection} isNewForm={isNewForm} />
        </div>
      </Section>

      {/* @TODO: Hide Provident Fund for Vietnam */}
      {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
      {/*
      <AnchorTarget name="ProvidentFundInformation" />
      <Section title={t("features.Clients.components.ProvidentFundSection.provident_fund_setting")}>
        <div>
          <FieldArray name="clientProvidentFunds" component={ProvidentFundSection} isNewForm={isNewForm} />
        </div>
      </Section>
      */}

      <AnchorTarget name="ClientPhoto" />
      <Section title={t("features.Clients.components.ImageSection.client_photo")}>
        <FormSection name="client">
          <ImageSection isNewForm={isNewForm} />
        </FormSection>
      </Section>

      <div className="u-ta-c u-mt20">
        <Button as="a" href={CLIENT_SHOW} className="u-mr20">
          {t("components.BonusFormModal.Cancel")}
        </Button>
        <Button disabled={pristine || submitting || anyApiRunning} onClick={handleSubmit} primary>
          {t('components.BonusFormModal.Save')}
        </Button>
      </div>
    </form>
  );
};


const ClientForm = scrollSpy(
  ({ formValues, naviSubmit, current, submitting, pristine, submit, anyApiRunning, handleSubmit, isNewForm, errors, inputedSupports, dispatch, image, ...rest }) => {
    const { t } = useTranslation();
    const { addToast } = useToasts();

    return (
      <div>
        <div className="l-flex">
          <div className="l-flex6-sub">
            <Affix offset={271} className={styles.navi}>
              <ListGroup>
                <Anchor name="OfficeInfomation" current={current}>
                  {t("features.Settings.Settings.office_information")}
                </Anchor>
                <Anchor name="BranchInfomation" current={current}>
                  {t("features.Clients.components.BranchInfoSectionShow.branch_information")}
                </Anchor>
                <Anchor name="TransferSourseAccoutInformation" current={current}>
                  {t("features.Clients.ShowClient.transfer_source_account_information")}
                </Anchor>
                {/* @TODO: Hide Provident Fund for Vietnam */}
                {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
                {/*
                <Anchor name="ProvidentFundInformation" current={current}>
                  {t("features.Clients.ShowClient.provident_fund_setting")}
                </Anchor>
                */}
                <Anchor name="ClientPhoto" current={current}>
                  {t("features.Clients.components.ImageSection.client_photo")}
                </Anchor>
                <ListGroup.Item>
                  <FormSubmitBtn
                    {...{ submitting }}
                    submit={handleSubmit}
                    text={t("features.EmployeeBonus.components.ActionButtonSection.save")}
                    widthWide
                    disabled={anyApiRunning || submitting || pristine}
                    disabledReason={anyApiRunning ? "CSVで従業員情報を更新中なので変更できません" : null}
                  />
                </ListGroup.Item>
              </ListGroup>
            </Affix>
          </div>
          <div className="l-flex6-main">
            <DetailClientForm {...{ anyApiRunning, handleSubmit, submit, isNewForm, errors, pristine, submitting, formValues }} {...rest} />
          </div>
        </div>
      </div>
    );
  }
);


export default connect(state => ({
  formValues: getFormValues(CLIENT_FORM)(state)
}))(ClientForm);
